module.exports = __webpack_public_path__ + "img/8.285faf40.jpg";